/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_FeaturedInputs */

const en_directory_hubs_signals_featured = /** @type {(inputs: Directory_Hubs_Signals_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured products`)
};

const zh_directory_hubs_signals_featured = /** @type {(inputs: Directory_Hubs_Signals_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精选产品`)
};

/**
* | output |
* | --- |
* | "Featured products" |
*
* @param {Directory_Hubs_Signals_FeaturedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_featured = /** @type {((inputs?: Directory_Hubs_Signals_FeaturedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_FeaturedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_featured(inputs)
	return zh_directory_hubs_signals_featured(inputs)
});
export { directory_hubs_signals_featured as "directory.hubs.signals.featured" }